import React, { FC } from 'react';
import { TaskStatusType } from 'api/status-updates';
import { TaskType } from 'api/tasks';
import styles from './draggable.module.css';

interface Props {
  commandName: string;
  commandOptions?: {
    [key: string]: any;
  };
  type: string;
}

export const Draggable: FC<Props> = ({
  children,
  commandName,
  commandOptions = {},
  type,
}) => {
  return (
    <div
      data-cy={type}
      className={styles.draggable}
      draggable="true"
      onDragStart={(event) => {
        const resourceTemplateSectionId = Number(new Date());

        event.dataTransfer.setData(
          'application/json',
          `{
              "ckWidgetCommandName": "${commandName}",
              "ckWidgetCommandOptions": ${JSON.stringify(commandOptions)},
              "options": {
                "resourceTemplateSectionId": "${resourceTemplateSectionId}",
                "resourceTemplateSectionType": "${
                  commandOptions.type || TaskType.Task
                }",
                "resourceTemplateSectionFilterType": "${
                  commandOptions.resourceTemplateSectionFilterType ||
                  TaskStatusType.Completed
                }",
                "resourceTemplateSectionFilterRangeStr": "${
                  commandOptions.resourceTemplateSectionFilterRangeStr
                }",
                "resourceTemplateSectionFilterWeeksRange": "${
                  commandOptions.resourceTemplateSectionFilterWeeksRange
                }"
              }
            }`,
        );
      }}
    >
      {children}
    </div>
  );
};
